import React from "react";
import { StoreyMeasurementContext } from "./storey-measurement-context-props.ts";

const useStoreyMeasurementContext = () => {
    const measurementContext = React.useContext(StoreyMeasurementContext);
    if (measurementContext === undefined) {
        throw new Error('useStoreyMeasurementContext must be used within a StoreyMeasurementProvider');
    }
    return measurementContext;
};

export default useStoreyMeasurementContext;
